import { useUniqueIdRoot } from 'app/components/common/UniqueIdRoot';
import React, { FunctionComponent, ReactNode, useEffect, useState } from 'react';

export const useUniqueId = (hint: string = 'unique-id') => {
  const service = useUniqueIdRoot();
  const [numberId] = useState<number>(() => service ? service.next() : 0);

  useEffect(() => {
    return () => {
      // This is not called in SSR scenarios so if you care about
      // reproductible ids, you should create a new instance of `Unique`
      // service for each SSR session
      if (service) {
        service.release(numberId);
      }
    };
  }, [service, numberId]);

  return `${hint}-${numberId}`;
};

interface IProps {
  hint?: string;
  children: (stringId: string) => ReactNode;
}

/**
 * Provides the `props.children(id)` function with a unique `id`,
 * stable for the lifetime of this component. Requires
 * `<SetUniqueIdRoot>` to be up the tree.
 *
 * The id can be prefixed with a `hint` prop to ease debugging with
 * the DOM inspector
 */
const UniqueId: FunctionComponent<IProps> = ({ hint, children }) => {
  const uniqueId = useUniqueId(hint);
  return <>{children(uniqueId)}</>;
};

export default UniqueId;
